// extracted by mini-css-extract-plugin
module.exports = {"faqContainer":"FaqSection-module--faqContainer--2oXeo"};